import axios from 'axios' 
const API_URL = '/api/entries/'

const createEntry = async (entryData, token) => {
  const config = {
    headers: {     
      Authorization: `Bearer ${token}`,    
    }
  }

  const response = await axios.post(API_URL, entryData, config)    
  return response.data;
}

const getEntries = async (token) => { 
  const config = { 
    headers: {
      Authorization: `Bearer ${token}`,    
    }
  }
  const response = await axios.get(API_URL, config)      
  return response.data;
}

const deleteEntry = async (entryId, token) => {      
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,    
    }
  }
  const response = await axios.delete(API_URL + entryId, config)   
  return response.data;
}

const updateEntry = async (
  entryId, 
  entryName,      // all this replaces "entryData"
  entryAlias, 
  entryMedicalCond, 
  entryRfa, 
  // entryImage,
  token) => {   // from thehamzajunaid's github
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  // Hamza's
  // const response = await axios.put(API_URL + goalID, {text: goalText}, config)
  // Mine:
  // const response = await axios.put(API_URL + entryId, {text: entryData}, config)

  const response = await axios.put(API_URL + entryId, {
    name: entryName, 
    alias: entryAlias,
    medicalCond: entryMedicalCond,
    rfa: entryRfa
    // image: entryImage
  }, config)

  return response.data;
}

const entryService = {
  createEntry,
  getEntries,
  deleteEntry,
  updateEntry,
}

export default entryService // exported to entrySlice.js